import * as React from "react";
const NextArrowSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <path
      fill="var(--color-primary)"
      fillRule="nonzero"
      d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm3.707 16.707-4.5 4.5a.997.997 0 0 1-.707.293c-.883 0-1.339-1.075-.707-1.707L17.586 16l-3.793-3.793a1 1 0 0 1 1.414-1.414l4.5 4.5a1 1 0 0 1 0 1.414z"
    />
  </svg>
);
export default NextArrowSvg;
